/**
 * Build a map of message id → readers whose last-read cursor lands on that
 * message (latest loaded message with id <= last_read_message_id).
 * Excludes the current viewer.
 *
 * @param {Array<Object>} messages - Loaded messages (any order)
 * @param {Array<Object>} otherMembers - chat.other_members
 * @param {number} userId - Current viewer id
 * @returns {Map<number, Array<{ user_id: number, name: string, pfp: string }>>}
 */
export function buildReadersByMessageId(messages, otherMembers, userId) {
  const byMessageId = new Map();
  const sorted = (messages || [])
    .filter((m) => m?.id != null)
    .slice()
    .sort((a, b) => Number(a.id) - Number(b.id));

  if (sorted.length === 0) {
    return byMessageId;
  }

  const viewerId = Number(userId);

  for (const member of otherMembers || []) {
    const peerId = Number(member.user_id);
    if (!peerId || peerId === viewerId) continue;

    const cursor = Number(member.last_read_message_id) || 0;
    if (cursor <= 0) continue;

    let target = null;
    for (const message of sorted) {
      const id = Number(message.id);
      if (id <= cursor) {
        target = message;
      } else {
        break;
      }
    }
    if (!target) continue;

    const messageId = Number(target.id);
    const readers = byMessageId.get(messageId) || [];
    readers.push({
      user_id: peerId,
      name: member.name || member.username || "User",
      pfp: member.pfp || member.pfp_url || "",
    });
    byMessageId.set(messageId, readers);
  }

  return byMessageId;
}
